//@ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserDescCell} from './UserDescCell'
import {UserNameCell} from './UserNameCell'
import {UserDateCell} from './UserDateCell'
// import {UserLastLoginCell} from './UserLastLoginCell'
// import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
//import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
//import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'

const UserColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='COMMON.INPUT_NAME' className='min-w-150px' />
    ),
    id: 'firstname',
    Cell: ({...props}) => <UserInfoCell User={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='COMMON.INPUT_USERNAME' className='min-w-100px' />
    ),
    id: 'username',
    Cell: ({...props}) => <UserNameCell User={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='COMMON.TYPE_USER' className='min-w-80px ' />
    ),
    id: 'roles',
    Cell: ({...props}) => <UserDescCell User={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='COMMON.CREATED_AT' className='min-w-125px' />
    ),
    id: 'created_at',
    Cell: ({...props}) => <UserDateCell User={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center min-w-50px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell data={props.data[props.row.index]} />,
  },
]

export {UserColumns}
